import { PERMISSION } from '@/constants/permission.constant';

const list = () => import('@/views/sell-car/List.vue');
const edit = () => import('@/views/sell-car/Edit.vue');

export const sellCarRoute = [
  {
    path: '/inbox/sell-car',
    name: 'sell-car-list',
    component: list,
    meta: { requiresAuth: false, permissions: [PERMISSION.INBOX_SELL_CAR_READ] },
  },
  {
    path: '/inbox/sell-car/:id/edit',
    name: 'sell-car-update',
    component: edit,
    meta: { requiresAuth: false, permissions: [PERMISSION.INBOX_SELL_CAR_UPDATE] },
  },
];
